<template>
  <div id="contents" class="cart contents">
    <contents-none
      v-if="isCartEmpty"
      :none-text="$t('cart.empty_cart')"
    ></contents-none>
    <template v-else>
      <p class="msgHeader">
        {{ $t('cart.cart_save_duration') }}
      </p>
      <div class="cartProductSelect">
        <form-checkbox
          id="cartAll"
          name="cartSelect"
          :labelText="$t('cart.select_all')"
          :checked="isAllChecked"
          :disabled="cartProductsAvailable.length === 0"
          @handleCheck="handleCheck"
        ></form-checkbox>
      </div>
      <div class="cartProduct">
        <ul class="listTypeCart">
          <li
            class="productItem"
            :class="{
              disable: product.productStatus !== 2 && !product.countLimit
            }"
            v-for="(product, index) in cartProducts"
            :key="index"
          >
            <form-checkbox
              :id="'checkbox_' + product.productId"
              name="cartSelect"
              :checked="product.checked"
              :disabled="product.productStatus !== 2 || product.countLimit"
              @handleCheck="handleCheck(product)"
            ></form-checkbox>
            <button
              type="button"
              class="btDelete"
              @click="openModalRemoveProductFromCart(product.productId)"
            >
              <span class="icon iconDel"></span>
              <span class="accessibilityHide">삭제</span>
            </button>
            <product-item
              :product="product"
              v-bind:isSaleAfter="true"
            ></product-item>
            <div class="productTotal">
              <form-select-amount
                :quantity.sync="product.purchaseCount"
                @handleQuantity="
                  newQuantity => {
                    handleQuantity(product, newQuantity)
                  }
                "
              ></form-select-amount>
              <span class="productPriceTotal">
                {{
                  $t('common.unit_with_value.unit_currency', {
                    value: (product.price * product.purchaseCount).addComma()
                  })
                }}
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="cartPrice">
        <dl>
          <dt>{{ $t('cart.total_product_amount') }}</dt>
          <dd>
            {{
              $t('common.unit_with_value.unit_currency', {
                value: cartTotalPrice.displayPrice.addComma()
              })
            }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('cart.discount_amount') }}</dt>
          <dd>
            -{{
              $t('common.unit_with_value.unit_currency', {
                value: cartTotalPrice.benefit.addComma()
              })
            }}
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('cart.total_payment_amount') }}</dt>
          <dd>
            {{
              $t('common.unit_with_value.unit_currency', {
                value: cartTotalPrice.price.addComma()
              })
            }}
          </dd>
        </dl>
      </div>
    </template>
    <div class="cartBtSec">
      <div>
        <dl>
          <dt>{{ $t('cart.total_payment_amount') }}</dt>
          <dd>
            {{
              $t('common.unit_with_value.unit_currency', {
                value: cartTotalPrice.price.addComma()
              })
            }}
          </dd>
        </dl>
      </div>
      <button
        type="button"
        class="button13 btDelete"
        :disabled="isCartEmpty"
        @click="handleClick('delete')"
      >
        <span class="icon iconDelete"></span>
        <span class="accessibilityHide">
          {{ $t('common.accessibility.delete_selected') }}
        </span>
      </button>
      <button
        type="button"
        class="button11 btBuy"
        :disabled="isCartEmpty"
        @click="handleClick('order')"
      >
        {{ $t('cart.purchase') }}
      </button>
    </div>
  </div>
</template>

<script>
import FormCheckbox from '@/views/base/FormCheckbox'
import FormSelectAmount from '@/views/base/FormSelectAmount'
import ContentsNone from '@/views/base/ContentsNone'
import ProductItem from '@/views/base/ProductItem'
import { beforeSendLog } from '@/utils'
import PaymentAPI from '@/api/payment'

import vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Cart',
  components: {
    FormCheckbox,
    FormSelectAmount,
    ContentsNone,
    ProductItem
  },
  data() {
    return {
      timerId: null
    }
  },
  computed: {
    ...mapGetters('cart', [
      'purchaseCheckList',
      'cartProducts',
      'cartProductsAvailable',
      'checkedCartProducts',
      'cartTotalPrice',
      'isAllChecked'
    ]),
    isCartEmpty() {
      return this.cartProducts.length < 1
    },
    isNoLimit() {
      let result = true
      const { limitPrice } = this.cartTotalPrice
      for (let productType in limitPrice) {
        const index = this.purchaseCheckList.findIndex(
          el => el.productType === productType
        )
        if (index > -1) {
          result =
            result &&
            limitPrice[productType] <=
              this.purchaseCheckList[index].payableAmount
          if (result == false) break
        }
      }
      return result
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModal',
      'openModalRemoveProductFromCart',
      'openModalRemoveSelectedProductFromCart'
    ]),
    ...mapActions('cart', [
      'getProductListOfCart',
      'increaseProductOfCart',
      'decreaseProductOfCart',
      'updateProductStatus',
      'updateAllProductCheckStatus'
    ]),
    handleQuantity(product, quantity) {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        if (quantity > 0) {
          this.increaseProductOfCart(product)
        } else {
          this.decreaseProductOfCart(product)
        }
      }, 300)
    },
    handleCheck(product) {
      if (typeof product === 'undefined') {
        this.updateAllProductCheckStatus(!this.isAllChecked)
      } else if (product) {
        this.updateProductStatus({ ...product, checked: !product.checked })
      }
    },
    handleClick(type) {
      const { checkedCartProducts } = this
      if (checkedCartProducts.length) {
        if (type === 'order') {
          const { price, displayPrice } = this.cartTotalPrice
          if (this.isNoLimit) {
            console.log('checkedCartProducts', checkedCartProducts)

            PaymentAPI.checkPolicyProductsInCart(
              {
                price,
                displayPrice,
                productList: checkedCartProducts
              },
              ({ code }) => {
                if (code === 0) {
                  beforeSendLog('Order')
                  this.$router.push({
                    name: 'order',
                    params: { productList: checkedCartProducts }
                  })
                }
              }
            )
          } else {
            this.openModal({
              type: 'alert',
              message: this.$t('alert.payment_exceeded_limit')
            })
          }
        } else if (type === 'delete') {
          this.openModalRemoveSelectedProductFromCart(checkedCartProducts)
        }
      } else {
        this.openModal({
          type: 'alert',
          message:
            type === 'order'
              ? this.$t('alert.select_product_to_purchase')
              : this.$t('alert.select_product_to_delete')
        })
      }
    }
  },
  mounted() {
    this.getProductListOfCart()
  },
  destroyed() {
    clearTimeout(this.timerId)
  }
}
</script>

<style lang="scss">
.cart {
  .productItem .productDeco .productAmount {
    display: none;
  }
}
.msgHeader {
  height: 42px;
  padding: 17px 16px 0;
  text-align: right;
  font-size: 11px;
  color: #545467;
}
.cartProductSelect {
  height: 42px;
  padding: 11px 0 0 16px;
  margin-top: -42px;
}

.cartProduct {
  .listTypeCart {
    padding: 0;
    .productItem {
      padding: 10px 16px 10px 44px;
      background-color: #fff;
      &.disable {
        .productDeco > *:not(.productImg),
        .productImg img,
        .productTotal {
          opacity: 0.5;
        }
      }
    }
    /* .soldout {
      &::before,
      &::after {
        position: absolute;
        display: block;
      }
      &::before {
        content: '';
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0.5);
        z-index: 1;
      }
      &::after {
        content: '일시품절';
        top: 71px;
        left: 37px;
        width: 85px;
        height: 17px;
        padding-top: 8px;
        text-align: center;
        font-size: 11px;
        color: #fff;
        background-color: #151721;
        z-index: 10;
      }
    } */
    .customCheckbox {
      position: absolute;
      top: 10px;
      left: 16px;
    }
    .btDelete {
      position: absolute;
      top: 5px;
      right: 11px;
      width: 27px;
      height: 27px;
      z-index: 1;
      .icon {
        vertical-align: top;
      }
    }
    .productDeco {
      position: relative;
      min-height: 87px;
      padding-left: 95px;
    }
    .productTotal {
      display: block;
      padding-top: 10px;
      margin-top: 10px;
      border-top: 1px solid #d6d6db;
    }
    .formSelectAmount {
      display: inline-block;
      width: 50%;
    }
    .productPriceTotal {
      display: inline-block;
      width: 50%;
      padding-top: 9px;
      text-align: right;
      font-size: 15px;
      color: #6134f1;
    }
  }
}
.cartPrice {
  padding: 13px 16px 0;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  dl {
    display: table;
    width: 100%;
    height: 26px;
  }
  dt,
  dd {
    display: table-cell;
  }
  dt {
    font-size: 13px;
    color: #636376;
  }
  dd {
    font-size: 15px;
    text-align: right;
  }
  dl:last-child {
    margin-top: 3px;
    font-weight: bold;
    border-top: 1px solid #636376;
    dt,
    dd {
      padding-top: 14px;
      height: 44px;
      font-size: 16px;
      color: #151721;
    }
    dd {
      font-weight: bold;
    }
  }
}

.cartBtSec {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  max-width: 1024px;
  // height: 55px; safeArea
  left: 50%;
  transform: translateX(-50%);
  padding-left: 70px;
  background-color: #fff;
  z-index: 11;
  div {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: -35px;
    width: 100%;
    height: 35px;
    background-color: #fff;
    border-top: 1px solid #636376;
    dl {
      display: table;
      width: 100%;
      max-width: 640px;
      padding: 0 16px;
      margin: 0 auto;
    }
    dt,
    dd {
      display: table-cell;
      padding-top: 11px;
    }
    dt {
      font-size: 13px;
      color: #151721;
    }
    dd {
      font-size: 14px;
      text-align: right;
      color: #6134f1;
      font-weight: bold;
    }
  }
  .btDelete {
    position: absolute;
    top: 0;
    left: 0;
    width: 70px;
  }
}
@media all and (min-width: 657px) {
  .cartBtSec {
    // padding-left: calc(70px + (50% - 320px));
    .btDelete {
      width: calc(70px + (50% - 320px));
    }
  }
}
</style>
